<template>
  <div class="details-audit-dialog">
    <el-dialog v-dialog-drag :visible.sync="showDialog" width="1100px" :destroy-on-close="true" :before-close="cancel"
      title="审核信息" class="audit-dialog">
      <div class="el-dialog-div">

       <div class="section-card audit-section">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-s-check"></i> 审核操作</span>
            <div>
              <el-button size="small" type="success" icon="el-icon-check" @click="handleApprove">确认审核</el-button>
            </div>
            
          </div>
          <el-form :model="approve" label-width="110px" ref="approve" :rules="approveRules" class="audit-form">
            <div style="display: flex">
              <el-form-item v-if="Object.keys(contract || {}).length > 0" label="合同审核" prop="contract" class="form-item-half">
                <el-radio-group v-model="approve.contract">
                  <el-radio label="SUCCESS" class="success-radio">
                    <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                  </el-radio>
                  <el-radio label="DEFEAT" class="danger-radio">
                    <i class="el-icon-error" style="color: #f56c6c;"></i> 拒绝
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

            <div v-if="approve.contract === 'DEFEAT'" style="margin-bottom: 30px">
              <el-form-item label="合同审核理由" prop="contractReason" class="form-item-full">
                <el-input type="textarea" v-model="approve.contractReason" placeholder="请输入合同审核理由"></el-input>
              </el-form-item>
            </div>
            <el-form-item v-if="Object.keys(record || {}).length > 0" label="发票审核" prop="invoice" class="form-item-half">
              <el-radio-group v-model="approve.invoice">
                <el-radio label="SUCCESS" class="success-radio">
                  <i class="el-icon-success" style="color: #67c23a;"></i> 通过
                </el-radio>
                <el-radio label="DEFEAT" class="danger-radio">
                  <i class="el-icon-error" style="color: #f56c6c;"></i> 拒绝
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="approve.invoice === 'DEFEAT'" style="margin-bottom: 30px">
              <el-form-item label="发票审核理由" prop="invoiceReason" class="form-item-full">
                <el-input type="textarea"  v-model="approve.invoiceReason" placeholder="请输入发票审核理由"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>




        <el-tabs>
          <el-tab-pane label="合同信息" v-if="Object.keys(contract || {}).length > 0">
            <div class="section-card">
              <div class="section-header-bar" @click="toggleSection('baseInfo')">
                <div class="section-title"><i class="el-icon-s-order"></i> 合同基础信息</div>
                <i :class="sectionOpen.baseInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div class="detail-grid" v-show="sectionOpen.baseInfo">
                <div class="detail-item">
                  <span class="detail-label">合同编号</span>
                  <span class="detail-value">{{ contract.contractNumber }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">合同名称</span>
                  <span class="detail-value">{{ contract.contractName }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">销售</span>
                  <span class="detail-value">{{ contract.sales.name }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">有效期限</span>
                  <span class="detail-value"><el-tag size="small">{{ contract.expirationDate +
                      '年' }}</el-tag></span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">合同拟定时间</span>
                  <span class="detail-value">{{ contract.contractDraftingDate }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">合同金额</span>
                  <span class="detail-value"><span class="amount-text">{{
                    formatAmount(contract.contractAmount) }}</span></span>
                </div>
                <div class="detail-item"
                  v-if="['PREPAYMENTS', 'IMPORT_PREPAYMENTS'].includes(contract.contractType)">
                  <span class="detail-label">增值金额</span>
                  <span class="detail-value">{{ contract.addedAmount + '(' +
                    getProportion(contract.contractAmount,
                      contract.addedAmount) + ')' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">客户联系人</span>
                  <span class="detail-value">
                    <span v-if="contract?.customerContacts?.contactName">{{
                      contract.customerContacts.contactName }}</span>
                    <el-tag v-else type="danger" size="small">系统内未找到</el-tag>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">受托方</span>
                  <span class="detail-value">{{ contract?.baseCompany?.companyName }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">受托方联系人</span>
                  <span class="detail-value">{{ contract?.trusteeContacts?.name }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">合同分类</span>
                  <span class="detail-value">
                    <el-tag size="small"
                      :type="getContractColor(contract.contractType, 'tagType')" :style="{
                        color: getContractColor(contract.contractType, 'color'),
                        'background-color': getContractColor(contract.contractType, 'backgroundColor'),
                        'border-color': getContractColor(contract.contractType, 'borderColor')
                      }">
                      {{ getContractColor(contract.contractType, 'name') }}</el-tag>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">合同类型</span>
                  <span class="detail-value">{{ contract.projectType }}</span>
                </div>
                <div class="detail-item"
                  v-if="['返样/暂存样品', '预付款扣款（返样/暂存样品）'].includes(contract.projectType)">
                  <span class="detail-label">样品处理方式</span>
                  <span class="detail-value">{{ contract.sampleManagement === 'RETURN_SAMPLE' ?
                    '返样' : '暂存样品' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">核酸抽提</span>
                  <span class="detail-value">
                    <el-tag size="small" type="success"
                      v-if="contract.generateContractInfo?.extractionFlag">是</el-tag>
                    <el-tag size="small" type="danger" v-else>否</el-tag>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">创建时间</span>
                  <span class="detail-value">{{ contract.createTime }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">签订地点</span>
                  <span class="detail-value">{{ contract.signingPlace }}</span>
                </div>
                <div class="detail-item" v-if="contract.priceFilePath">
                  <span class="detail-label">价格申请截图</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="download(contract.id, 'price')">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="preview(contract.id, 'price')">预览</el-button>
                    </div>
                  </span>
                </div>
                <div class="detail-item" v-if="contract.contractFilePath">
                  <span class="detail-label">合同</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="download(contract.id, 'contract')">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="preview(contract.id, 'contract')">预览</el-button>
                    </div>
                  </span>
                </div>
                <div class="detail-item full-width" v-if="findProjectAnnexProject(contract)">
                  <span class="detail-label">需做的理化性质列表</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="downloadProjectAnnexFile(contract.id, findProjectAnnexProject(contract).projectMainTypeId)">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="previewProjectAnnexFile(contract.id, findProjectAnnexProject(contract).projectMainTypeId)">预览</el-button>
                    </div>
                  </span>
                </div>
                <div class="detail-item full-width">
                  <span class="detail-label">备注</span>
                  <span class="detail-value">{{ contract.remark }}</span>
                </div>
              </div>
            </diV>
           <div class="section-card" v-if="['预付款扣款（测序分析）', '测序分析'].includes(contract.projectType) && contract.contractType !== 'DEVELOPMENT' && Object.keys(contract.moreAnalysisRequest).length > 0">
              <div class="section-header-bar" @click="toggleSection('analysis')">
                <div class="section-title"><i class="el-icon-data-analysis"></i> 补充分析要求</div>
                <i :class="sectionOpen.analysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
             <div class="detail-grid" v-show="sectionOpen.analysis">
                <div class="detail-item" v-for="(item, index) in Object.keys(contract.moreAnalysisRequest)"
                  :key="index">
                  <span class="detail-label">{{analysis.find(itemA => itemA.label === item).name + '金额'}}</span>
                  <span class="detail-value"><span class="amount-text">{{
                    formatAmount(contract.moreAnalysisRequest[item]) }}</span></span>
                </div>
                <div class="detail-item" v-if="contract.seniorAnalysisAnnex">
                  <span class="detail-label">高级分析附件</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="download(contract.id, 'senior')">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="preview(contract.id, 'senior')">预览</el-button>
                    </div>
                  </span>
                </div>
                <div class="detail-item" v-if="contract.customizedAnalysisAnnex">
                  <span class="detail-label">个性化分析附件</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="download(contract.id, 'customized')">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="preview(contract.id, 'customized')">预览</el-button>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <div class="section-card"
              v-if="['预付款扣款（测序分析）', '预付款扣款（裸测）', '测序分析', '裸测'].includes(contract.projectType)">
              <div class="section-header-bar" @click="toggleSection('returnSample')">
                <div class="section-title"><i class="el-icon-refresh-left"></i> 返样</div>
                <i :class="sectionOpen.returnSample ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div class="detail-grid" v-show="sectionOpen.returnSample">
                <div class="detail-item">
                  <span class="detail-label">是否返样</span>
                  <span class="detail-value">{{ contract.generateContractInfo?.returnSampleBo?.returnSampleFlag ? '是' : '否' }}</span>
                </div>
                <div class="detail-item"
                  v-if="contract.generateContractInfo?.returnSampleBo?.returnSampleFlag">
                  <span class="detail-label">服务费(返样)</span>
                  <span class="detail-value"><span class="amount-text">{{
                    formatAmount(contract.generateContractInfo?.returnSampleBo?.returnSampleAmount)
                    }}</span></span>
                </div>
                <div class="detail-item full-width"
                  v-if="contract.generateContractInfo?.returnSampleBo?.returnSampleFlag && Number(contract.generateContractInfo?.returnSampleBo?.returnSampleAmount) === 0">
                  <span class="detail-label">金额为0原因</span>
                  <span class="detail-value">{{ contract.generateContractInfo?.returnSampleBo?.reason }}</span>
                </div>
              </div>
            </div>
            <div class="section-card"
              v-if="contract.specificProjectType && contract.specificProjectType.length > 0">
              <div class="section-header-bar" @click="toggleSection('projectInfo')">
                <div class="section-title"><i class="el-icon-s-order"></i> 项目信息</div>
                <i :class="sectionOpen.projectInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div v-show="sectionOpen.projectInfo">
                <project-info-dialog
                  :table-data="contract.specificProjectType"></project-info-dialog>
              </div>
            </div>
            <!-- 纯分析项目信息（仅团队纯分析合同展示） -->
            <div class="section-card" v-if="showPureAnalysisInfo">
              <div class="section-header-bar" @click="toggleSection('pureAnalysis')">
                <div class="section-title"><i class="el-icon-s-data"></i> 纯分析项目</div>
                <i :class="sectionOpen.pureAnalysis ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div v-show="sectionOpen.pureAnalysis">
                <div class="detail-grid">
                  <div class="detail-item">
                    <span class="detail-label">纯分析类型</span>
                    <span class="detail-value">{{ pureAnalysisTypeName }}</span>
                  </div>
                </div>
                <!-- 合同-项目分组表格：每行一组，清晰展示绑定关系 -->
                <div class="change-data-wrapper" v-if="pureAnalysisTableData.length > 0">
                  <el-table :data="pureAnalysisTableData" stripe style="width: 100%"
                    header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }">
                    <el-table-column label="序号" align="center" width="60">
                      <template slot-scope="scope">
                        <span>{{ scope.row.index }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="关联合同" align="center" min-width="180">
                      <template slot-scope="scope">
                        <span class="highlight-text">{{ scope.row.contractNumber }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="项目" align="center" min-width="250">
                      <template slot-scope="scope">
                        <el-tag v-for="(p, i) in scope.row.projects" :key="i" size="small"
                          style="margin: 2px 4px 2px 0;">{{ p }}</el-tag>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <!-- 解离项目投递方式信息展示 -->
            <div class="section-card" v-if="contract.protectiveFluidInfo?.protectiveFluidMethod">
              <div class="section-header-bar" @click="toggleSection('deliveryInfo')">
                <div class="section-title"><i class="el-icon-truck"></i> 解离项目投递方式</div>
                <i :class="sectionOpen.deliveryInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div class="detail-grid" v-show="sectionOpen.deliveryInfo">
                <div class="detail-item">
                  <span class="detail-label">投递方式</span>
                  <span class="detail-value">{{ contract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR' ? '上门' : (contract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL' ? '邮寄' : '') }}</span>
                </div>
                <template v-if="contract.protectiveFluidInfo.protectiveFluidMethod === 'DOOR'">
                  <div class="detail-item">
                    <span class="detail-label">上门时间</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.doorInfo.doorTime }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">上门费用</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.doorInfo.doorFee }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">联系方式</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.doorInfo.phone }}</span>
                  </div>
                  <div class="detail-item full-width">
                    <span class="detail-label">上门地址</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.doorInfo.address }}</span>
                  </div>
                </template>
                <template v-if="contract.protectiveFluidInfo.protectiveFluidMethod === 'MAIL'">
                  <div class="detail-item">
                    <span class="detail-label">邮寄时间</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.materialMailInfo.mailTime }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">收件人</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.materialMailInfo.recipient }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">联系方式</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.materialMailInfo.phone }}</span>
                  </div>
                  <div class="detail-item full-width">
                    <span class="detail-label">收件地址</span>
                    <span class="detail-value">{{ contract.protectiveFluidInfo.materialMailInfo.address }}</span>
                  </div>
                </template>
              </div>
            </div>
            <div class="section-card" v-if="flatMaterialTracking.length > 0">
              <div class="section-header-bar" @click="toggleSection('materials')">
                <div class="section-title"><i class="el-icon-box"></i> 物料信息</div>
                <i :class="sectionOpen.materials ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div class="change-data-wrapper" v-show="sectionOpen.materials">
                <el-table :data="flatMaterialTracking" stripe style="width: 100%" max-height="400"
                  header-row-class-name="headerTable" :cell-style="{ padding: '8px 0' }"
                  :span-method="materialSpanMethod">
                  <el-table-column label="物料状态" align="center" min-width="100">
                    <template slot-scope="scope">
                      <el-tag :type="scope.row.statusType" size="small">{{ scope.row.statusText }}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="物料名称" align="center" min-width="180">
                    <template slot-scope="scope">
                      <span class="material-name">{{ scope.row.materialName || findName(scope.row.materialId) || '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="specs" label="物料规格" align="center" min-width="120">
                    <template slot-scope="scope">
                      <span>{{ scope.row.specs || '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="number" label="申领数量" align="center" min-width="120">
                    <template slot-scope="scope">
                      <span class="quantity-text">{{ scope.row.number }} <span class="unit-text">支</span></span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div v-if="contract.hardDiskPurchaseInfo?.length > 0" class="section-card">
              <div class="section-header-bar" @click="toggleSection('hardDisk')">
                <div class="section-title"><i class="el-icon-s-order"></i> 硬盘选购信息</div>
                <i :class="sectionOpen.hardDisk ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div v-show="sectionOpen.hardDisk">
              <div class="sub-sub-section" v-for="(disk, index) in contract.hardDiskPurchaseInfo" :key="index">
                <div class="disk-info-row">
                  <div class="disk-info-item">
                    <div class="sub-sub-title">硬盘大小</div>
                    <div>{{ disk.hardDiskSize || '-' }}</div>
                  </div>
                  <div class="disk-info-item">
                    <div class="sub-sub-title">项目金额</div>
                    <div class="amount-text">{{ formatAmount(disk.projectAmount) }}</div>
                  </div>
                  <div class="disk-info-item">
                    <div class="sub-sub-title">数量</div>
                    <div>{{ (disk.sampleCount !== undefined && disk.sampleCount !== null) ? disk.sampleCount : '-' }}</div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="发票信息" v-if="Object.keys(record || {}).length > 0">
            <div class="section-card">
              <div class="section-header-bar" @click="toggleSection('invoiceInfo')">
                <div class="section-title"><i class="el-icon-s-ticket"></i> 发票信息</div>
                <i :class="sectionOpen.invoiceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </div>
              <div class="detail-grid" v-show="sectionOpen.invoiceInfo">
                <div class="detail-item">
                  <span class="detail-label">销售</span>
                  <span class="detail-value">{{ record['applicant'].name }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">申请时间</span>
                  <span class="detail-value">{{ record.applicationDate }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">是否连号</span>
                  <span class="detail-value">
                    <el-tag v-if="record.connectedFlag === 1" type="success" size="small">是</el-tag>
                    <el-tag v-else-if="record.connectedFlag === 0" type="warning" size="small">否</el-tag>
                    <el-tag v-else type="info" size="small">未知状态</el-tag>
                  </span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">是否同一天</span>
                  <span class="detail-value">
                    <el-tag v-if="record.sameDayFlag === 1" type="success" size="small">是</el-tag>
                    <el-tag v-else-if="record.sameDayFlag === 0" type="warning" size="small">否</el-tag>
                    <el-tag v-else type="info" size="small">未知状态</el-tag>
                  </span>
                </div>
                <div class="detail-item" v-if="record['annex']">
                  <span class="detail-label">试剂清单</span>
                  <span class="detail-value">
                    <div class="attachment-actions">
                      <el-button size="mini" type="primary" icon="el-icon-download" plain
                        @click="download(record.id, 'record')">下载</el-button>
                      <el-button size="mini" type="primary" icon="el-icon-view" plain
                        @click="preview(record.id, 'record')">预览</el-button>
                    </div>
                  </span>
                </div>
                <div class="detail-item full-width"
                  v-if="record.sameDayFlag === 0">
                  <span class="detail-label">开票日期备注</span>
                  <span class="detail-value">{{ record.remark }}</span>
                </div>
                
              </div>
            </div>

            <div class="sub-section">
              <div class="sub-section-title">
                <span><i class="el-icon-money"></i> 合同金额详情</span>
              </div>
              <div>
                <div v-for="(contract, index) in record['contractInfoList']" :key="index" class="contract-detail-row">
                  <span class="contract-index">{{ index + 1 }}</span>
                  <div class="detail-grid" style="width: 100%!important;">
                    <div class="detail-item">
                      <span class="detail-label">合同名称</span>
                      <span class="detail-value">{{ contract.contractName }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">合同状态</span>
                      <span class="detail-value">
                        <el-tag :type="status.find(item => item.status === contract.status).type">{{status.find(item =>
                          item.status === contract.status).name}}</el-tag>
                      </span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">合同编号</span>
                      <span class="detail-value">{{ contract.contractNumber }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">合同金额</span>
                      <span class="detail-value"><span class="amount-text">{{ formatAmount(contract.contractAmount)
                      }}</span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sub-section">
              <div class="sub-section-title">
                <span><i class="el-icon-document"></i> 开票具体详情</span>
              </div>
              <div>
                <invoice-info-dialog :select-detail="record" type="audit" :principal-uuids="record['principalUuids']"
                  :person-options="PersonOptions" @submit="getPrincipal"></invoice-info-dialog>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
    <file-preview v-if="showFile" :show-dialog="showFile" :response="fileInfo" @submit="close"></file-preview>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {attachmentContract, getAllContract} from "@/api/dilivery/sales/contract";
import {getProjectList} from "@/api/dilivery/project";
import {downloadRecord} from "@/api/dilivery/record";
import {getPersonByType} from "@/api/dilivery/customer/person";
import FilePreview from "@/components/file/FilePreview.vue";
import ProjectInfoDialog from "@/components/sales/ProjectInfoDialog.vue";
import InvoiceInfoDialog from "@/components/invoice/InvoiceInfoDialog.vue";
import {auditContractInvoice} from "@/api/dilivery/audit";
import {getContractColor} from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";
import { getProportion } from "@/utils/float_decimal";
import projectAnnexMixin from "@/mixins/projectAnnexMixin";
import detailCommonMixin from "@/mixins/detailCommonMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "DetailsAuditDialog",
  mixins: [projectAnnexMixin, detailCommonMixin],
  components: { InvoiceInfoDialog, ProjectInfoDialog, FilePreview, Loading },
  props:{
    showDialog:{
      default:false
    },
    contractDetail:{
      default: () => ({})
    },
    recordDetail:{
      default: () => ({})
    },
  },
  computed: {
    flatMaterialTracking() {
      return this._buildFlatMaterialTracking(this.contract?.protectiveFluidMail, this.contract?.materials)
    },
    pureAnalysisInfo() {
      return this.contract.pureAnalysisInfo || {}
    },
    showPureAnalysisInfo() {
      const info = this.pureAnalysisInfo
      const hasContracts = Array.isArray(info.contracts) &&
        info.contracts.some(c => c.contractId || (c.projectIds && c.projectIds.length))
      return this.contract.contractType === 'TEAM' &&
        this.contract.projectType === '纯分析' &&
        !!(info.pureAnalysisType || hasContracts)
    },
    pureAnalysisTypeName() {
      // 与后端 pureAnalysisType 枚举保持一致
      const enumMap = {
        AFTER_SALES_ANALYSIS: '售后分析',
        RAW_DATA_RERELEASE: '原始数据重释放',
        PURE_ANALYSIS: '纯分析'
      }
      const val = this.pureAnalysisInfo.pureAnalysisType
      if (!val) return '-'
      return enumMap[val] || val
    },
    // 按组解析：每组包含 contractId / projectIds / 已加载的合同对象
    pureAnalysisContracts() {
      const contracts = Array.isArray(this.pureAnalysisInfo.contracts) ? this.pureAnalysisInfo.contracts : []
      return contracts.map(c => ({
        contractId: c.contractId,
        projectIds: Array.isArray(c.projectIds) ? c.projectIds : [],
        contract: c.contractId ? (this.enforceContractOption.find(x => String(x.id) === String(c.contractId)) || null) : null
      }))
    },
    // 按组生成表格数据：每行一组合同+项目，清晰展示绑定关系
    pureAnalysisTableData() {
      const list = this.pureAnalysisContracts
      if (list.length === 0) return []
      return list.map((g, idx) => {
        const spt = g.contract?.specificProjectType || []
        const projects = g.projectIds.map(pid => {
          // 优先从项目字典解析：仅展示具体项目名（不含 model 前缀）
          const dictItem = this.projectOption.find(item => String(item.id) === String(pid))
          if (dictItem) return dictItem.name
          // 兜底：从合同 specificProjectType 解析（兼容旧数据，仅展示具体项目名）
          const proj = spt.find(p => String(p.projectMainTypeId) === String(pid))
          return proj ? proj.projectType : pid
        })
        return {
          index: idx + 1,
          contractNumber: g.contract ? g.contract.contractNumber : (g.contractId || '-'),
          projects: projects.length ? projects : ['-']
        }
      })
    }
  },
  data() {
    return {
      loading:false,
      AnalysisEvaluate:[],
      showFile: false,
      fileInfo: '',
      sectionOpen: {
        baseInfo: true,
        analysis: true,
        returnSample: true,
        projectInfo: true,
        pureAnalysis: true,
        deliveryInfo: true,
        materials: true,
        hardDisk: true,
        invoiceInfo: true,
        contractAmount: true,
      },
      projectOption: [],
      enforceContractOption: [],
      PersonOptions: [],
      principalUuids:{},
      status:[
        {status: 'SUCCESS', type: 'success', name: '已通过'},
        {status: 'APPLYING', type: 'warning', name: '待审核'},
        {status: 'EVALUATING', type: 'primary', name: '待评估'},
        {status: 'DEFEAT', type: 'danger', name: '已驳回'},
        {status: 'DERELICT', type: 'info', name: '废弃'},
      ],
      analysis:[
        {label:'SENIOR_ANALYSIS',name:'高级分析'},
        {label:'STANDARD_ANALYSIS',name:'标准分析'},
        {label:'CUSTOMIZED_ANALYSIS',name:'个性化分析'},
      ],
      contract:{},
      record:{},
      approve: {
        contract: '',
        contractReason: '',
        invoice: '',
        invoiceReason: '',
      },
      approveRules: {
        contract: [{required: true, message: '合同审核不能为空', trigger: 'change'}],
        contractReason: [{required: true, message: '审核原因不能为空', trigger: 'change'}],
        invoice: [{required: true, message: '发票审核不能为空', trigger: 'change'}],
        invoiceReason: [{required: true, message: '审核原因不能为空', trigger: 'change'}],
      }

    };
  },
  watch: {
    contractDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.contract = {
            ...newVal,
            status: '',
            rejectionReason: '',
            hardDiskPurchaseInfo: newVal.hardDiskPurchaseInfo ?? [],
            protectiveFluidMail: newVal.protectiveFluidMail ?? [],
          }
          if (newVal.contractType === 'TEAM' && newVal.projectType === '纯分析' && newVal.pureAnalysisInfo) {
            this.loadPureAnalysisOptions()
          }
        }
      },
      immediate: true
    },
    recordDetail: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.record = {
            ...newVal,
            status: '',
            rejectionReason: '',
            principalUuids: newVal.invoiceInfoDTOS.reduce((acc, itemA) => {
              if (itemA.principalUuid !== null) {
                acc[itemA.id] = itemA.principalUuid;
              } else {
                acc[itemA.id] = '';
              }
              return acc;
            }, {})
          }
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.getPersonOptions()
    this.getLexiconOptions()
  },
  methods: {
    getProportion,
    getContractColor,
    // 加载纯分析项目展示所需的合同选项（按各组 contractId 定向获取）
    async loadPureAnalysisOptions() {
      try {
        // 加载项目字典（供纯分析项目名称解析，与 AddEditCRM.vue getProjectOptions 保持一致）
        if (this.projectOption.length === 0) {
          const projRes = await getProjectList({})
          if (projRes.code === 200) {
            this.projectOption = (projRes.data || []).filter(item => !item.deprecated)
          }
        }
        const contracts = Array.isArray(this.pureAnalysisInfo.contracts) ? this.pureAnalysisInfo.contracts : []
        const ids = contracts.map(c => c.contractId).filter(Boolean)
        if (ids.length === 0) return
        const typeMap = { AFTER_SALES_ANALYSIS: 'ANALYSIS_OVER_CONTRACT', RAW_DATA_RERELEASE: 'RELEASED_RAW_DATA_CONTRACT' }
        const contractType = typeMap[this.pureAnalysisInfo.pureAnalysisType]
        if (!contractType) return
        const missing = ids.filter(id => !this.enforceContractOption.some(c => String(c.id) === String(id)))
        if (missing.length === 0) return
        const res = await getAllContract(contractType, { 'query#id.IN': missing.join(',') })
        if (res.code === 200 && Array.isArray(res.data)) {
          this.enforceContractOption = [...this.enforceContractOption, ...res.data]
        }
      } catch (error) {
        console.log(error);
      }
    },
    getPrincipal(value){
      this.principalUuids = value
    },
    async download(id, type) {
      await this.downloadContractAttachment(id, type)
    },
    async preview(id, type) {
      await this.previewContractAttachment(id, type)
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    handleApprove() {
      this.$refs.approve.validate(valid => {
        if (valid) {
          if (Object.keys(this.contract || {}).length > 0 && Object.keys(this.record || {}).length > 0) {
            if (this.approve.contract === 'DEFEAT' && this.approve.invoice === 'SUCCESS') {
              this.$messageUi.error('合同审核拒绝时，发票审核不能为通过')
              return
            }
          }
          this.loading = true
          const formData = new FormData();
          if (Object.keys(this.contract || {}).length > 0) {
            let sendData = {
              id: this.contract.id,
              status: this.approve.contract,
              rejectionReason: this.approve.contractReason,
            }
            const jsonStrContract = JSON.stringify(sendData);
            const blobContract = new Blob([jsonStrContract], {
              type: 'application/json'
            });
            formData.append("contract", blobContract);
          }
          if (Object.keys(this.record || {}).length > 0 && this.approve.contract !== 'DEFEAT') {
            let sendData = {
              id: this.record.id,
              status: this.approve.invoice,
              rejectionReason: this.approve.invoiceReason,
              principalUuids:this.principalUuids
            }
            const jsonStrInvoice = JSON.stringify(sendData);
            const blobContract = new Blob([jsonStrInvoice], {
              type: 'application/json'
            });
            formData.append("invoice", blobContract);
          }
          // const ApiMethod = this.analysisFlag?pureAudit:auditContractInvoice

          auditContractInvoice(formData).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$messageUi.success('提交成功')
              this.$store.commit('right/setChangeRed',true)
              this.$emit('submit', 'confirm')
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          this.$messageUi.error('信息填写不完整，请检查')
        }
      })
    },
    getPersonOptions() {
      getPersonByType('', { deptTypes: ["BUSINESS_COMMERCIAL"] }).then(res => {
        if (res.code === 200) {
          this.PersonOptions = res.data
        }
      }).catch(error => {
        this.$messageUi.error('获取商务专员信息失败')
        console.log(error);
      })
    },
    close() {
      this.showFile = false
    },
  }
}
</script>

<style lang="scss" scoped>
.details-audit-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
      .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";








.audit-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #fff 100%);
}

.audit-form {
  padding: 16px;
}

.audit-actions {
  display: flex;
  gap: 10px;
}

.success-radio {
  margin-right: 20px;
}

.danger-radio {
  margin-right: 0;
}

.info-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }
  
  ::v-deep .el-tabs__content {
    padding: 20px;
    border: 1px solid #e4e7ed;
    border-top: none;
    border-radius: 0 0 4px 4px;
  }
}

.tab-content {
  padding: 10px 0;
}

.contract-sub-tabs {
  margin-bottom: 20px;
}





.sub-sub-section {
  margin-top: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

.sub-sub-title {
  font-weight: 600;
  font-size: 13px;
  color: #606266;
  margin-bottom: 10px;
}



.info-descriptions {
  ::v-deep .el-descriptions__header {
    margin-bottom: 15px;
  }
}









.contract-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
}



.record-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 100;
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
  border-radius: 8px 8px 0 0;
  margin-bottom: 20px;
}

.danger-text {
  color: #f56c6c;
  font-weight: 500;
}

.info-form {
  display: flex;
  flex-wrap: wrap;
}

.form-item-half {
  width: 48%;
}

.form-item-full {
  width: 96%;
}

.disk-info-row {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.disk-info-item {
  flex: 1;
  min-width: 180px;
}


</style>
